@if (isContractor() &&
  currentContact?.femaTrained &&
  toggleOpenClosedProjects) {
  <div [hidden]="!ShowOpenApplications" style="margin-top: 18px;">
    <h6 style="margin-left: 15px;">Open Projects</h6>
  </div>
}

<div [hidden]="!ShowOpenApplications" >
  @if (toggleDisplayCardList) {
    <div>
      <div fxLayout="row wrap" fxLayout.xs="column wrap" style="margin-top: 18px;">
        @for (application of data; track application) {
          <div fxFlex.gt-xs="50%" [fxFlex.gt-md]="cardLayout">
            <div style="margin-top: 10px; margin-right: 10px;">
              <mat-card [class.mat-elevation-z7]='true'>
                <!-- Card Title -->
                <mat-card-title style="font-size: 16px;">{{application.name}}</mat-card-title>
                <mat-card-subtitle class="card-subtitle" style="font-size: 14px; margin-bottom: 9px;">
                  @if (isContractorOnApp(application)) {
                    <span>
                      Project number: {{application.applicationNumber}} ({{programTypeDesc(application.programType)}})
                    </span>
                  }
                  @if (isHomeownerOnApp(application)) {
                    <span>
                      Application number: {{application.applicationNumber}} ({{programTypeDesc(application.programType)}})
                    </span>
                  }
                </mat-card-subtitle>
                <mat-divider></mat-divider>
                <!-- Card Body -->
                <div >
                  <mat-card-content>
                    <div>
                      <span>
                        <span class="card-label">Program</span>
                        <span class="card-value">
                          {{application._Ebb_ProgramCycleId_Formatted}}
                          <br>
                            <span class="card-value-light">
                              (accepted {{getFormattedDate(application.acceptedDate.toString())}})
                            </span>
                          </span>
                        </span>
                      </div>
                      <div style="margin-top: 9px;">
                        <span>
                          <span class="card-label">Status</span>
                          @if (application.stateCode === 0) {
                            <div>
                              <div>
                                @switch (application.stageCode) {
                                  @case (700000000) {
                                    <div class="card-value">
                                      @if (application.applicationStatusOptionSet !== 'Extension' && application.programType !== 700000002) {
                                        <span>
                                          Pre-retrofit -
                                        </span>
                                      }
                                      @if (application.applicationStatusOptionSet === 'Extension') {
                                        <span>Extension - {{application.extensionDate | date: 'M/d/yyyy'}}</span>
                                      }
                                      @if (application.itemsRejectedRollup > 0) {
                                        <span>
                                          <span class="warn-text">
                                            Action Required
                                          </span>
                                        </span>
                                      } @else {
                                        @if (application.eventPreliminaryReview) {
                                          <span>
                                            @if (application.programType !== 700000002) {
                                              <span>
                                                Submitted
                                              </span>
                                            }
                                            @if (application.programType === 700000002) {
                                              <p>
                                                FEMA Review <span> - </span> <span [innerHTML]="femareviewmessage"
                                              style=" display: inline-block;color: #377491;"></span>
                                            </p>
                                          }
                                        </span>
                                      }
                                      @if (!application.eventPreliminaryReview) {
                                        <span>
                                          @if (isContractorOnApp(application) && !isHomeownerOnApp(application)) {
                                            <span class="warn-text">
                                              Upload Documents
                                            </span>
                                          }
                                          @if (isHomeownerOnApp(application)) {
                                            <span>
                                              @if (application.applicationStatusOptionSet !== 'Extension') {
                                                <span>In process</span>
                                              }
                                            </span>
                                          }
                                        </span>
                                      }
                                    }
                                  </div>
                                }
                                @case (700000001) {
                                  <div class="card-value">
                                    Post-retrofit -
                                    @if (application.itemsRejectedRollup > 0) {
                                      <span>
                                        <span class="warn-text">
                                          Action Required
                                        </span>
                                      </span>
                                    } @else {
                                      @if (application.eventApplicationSubmitted) {
                                        <span>
                                          Submitted
                                        </span>
                                      }
                                      @if (!application.eventApplicationSubmitted) {
                                        <span>
                                          <span class="accent-text">
                                            Proceed with Project
                                          </span>
                                        </span>
                                      }
                                    }
                                  </div>
                                }
                                @case (700000002) {
                                  <div class="card-value">
                                    Application In Review
                                    @if (application.itemsRejectedRollup) {
                                      <span>
                                        -
                                        <span class="warn-text">
                                          Action Required
                                        </span>
                                      </span>
                                    }
                                  </div>
                                }
                                @case (700000003) {
                                  <div class="card-value">
                                    Application In Review
                                    @if (application.itemsRejectedRollup) {
                                      <span>
                                        -
                                        <span class="warn-text">
                                          Action Required
                                        </span>
                                      </span>
                                    }
                                  </div>
                                }
                              }
                            </div>
                          </div>
                        }
                        @if (application.stateCode === 1) {
                          <div>
                            <div>
                              @switch (application.statusCode) {
                                @case (700000000) {
                                  <div class="card-value">
                                    <span class="accent-text">
                                      Paid
                                    </span>
                                  </div>
                                }
                                @case (700000001) {
                                  <div class="card-value">
                                    <span class="accent-text">
                                      Withdrawn
                                    </span>
                                  </div>
                                }
                              }
                            </div>
                          </div>
                        }
                      </span>
                    </div>
                    @if (isHomeownerOnApp(application)) {
                      <div style="margin-top: 9px;">
                        <div>
                          @switch (application.contractorTypeCode) {
                            @case (700000000) {
                              <div>
                                <span>
                                  <span class="card-label">Contractor</span>
                                  @if (application._Ebb_ContractorId_Formatted && application._Ebb_ContractorId_Formatted.length > 0) {
                                    <span
                                      class="card-value">
                                      {{application?.contractor?.businessName ? application.contractor.businessName : application._Ebb_ContractorId_Formatted}}
                                    </span>
                                  } @else {
                                    <span class="card-value">Contractor has not been selected</span>
                                  }
                                </span>
                              </div>
                            }
                            @case (700000001) {
                              <div>
                                <span>
                                  <span class="card-label">Contractor</span>
                                  <span class="card-value">Homeowner is doing retrofit</span>
                                </span>
                              </div>
                            }
                            @default {
                              <div>
                                <span>
                                  <span class="card-label">Contractor</span>
                                  <span class="card-value">Select a contractor <span class="card-value-light">(or do it yourself)</span></span>
                                </span>
                              </div>
                            }
                          }
                        </div>
                      </div>
                    }
                    @if (isContractorOnApp(application)) {
                      <div style="margin-top: 9px;">
                        <span>
                          <span class="card-label">Homeowner</span>
                          <span class="card-value">
                            <div>{{ application._Ebb_OwnerId_Formatted }}</div>
                            <div>{{ application.owner.emailAddress1 }}</div>
                            <div>{{ application.owner.telephone1 }}</div>
                          </span>
                        </span>
                      </div>
                    }
                    <!-- <div *ngIf="isContractorOnApp(application) && application.contractorInvitationCode === 700000001" style="margin-top: 12px;">
                    <span class="card-label">
                      <span class="accent-text">NEW</span>
                    </span>
                    <span class="card-value">
                      Request to upload documents on behalf of this homeowner
                    </span>
                  </div> -->
                  <div style="margin-top: 12px;">
                    <span class="card-label">
                      To Do
                    </span>
                    @if (application.itemsPendingRollup > 0) {
                      <div>
                        <span class="card-value">
                          {{application.itemsPendingRollup}} item@if (application.itemsPendingRollup > 1) {
                          <span>s</span>
                          } due@if (application.itemsRejectedRollup > 0) {
                          <span
                            >;
                            {{application.itemsRejectedRollup}} item@if (application.itemsRejectedRollup > 1) {
                            <span>s</span>
                          } to correct</span>
                        }
                      </span>
                    </div>
                  }
                  @if (application.itemsPendingRollup <= 0 && application.itemsRejectedRollup > 0) {
                    <div>
                      <span class="card-value">
                        {{application.itemsRejectedRollup}} item@if (application.itemsRejectedRollup > 1) {
                        <span>s</span>
                        } to correct
                      </span>
                    </div>
                  }
                  @if (application.itemsPendingRollup <= 0 && application.itemsRejectedRollup <= 0) {
                    <div>
                      <span class="card-value">
                        No items currently due
                      </span>
                    </div>
                  }
                  @if (isContractorOnApp(application)) {
                    <div style="margin-top: 12px;">
                      @if (isContractor() && application.contractorPermissionsCode === 700000001) {
                        <span class="card-value">
                          Contractor to upload documents.
                        </span>
                      }
                      @if (isContractor() && application.contractorPermissionsCode !== 700000001) {
                        <span class="card-value">
                          Homeowner to upload documents.
                        </span>
                      }
                    </div>
                  }
                </div>
              </mat-card-content>
            </div>
            <mat-divider></mat-divider>
            <!-- Card Actions -->
            <!-- 1: ALL Read-only; 2: Contractor Read-only; 3: ALL Edit -->
            <mat-card-actions>
              @if (checkUserAuthorization(application.stageCode, application.contractorPermissionsCode, application._Ebb_OwnerId, application._Ebb_ContractorId) === 1 && application.stageCode <= 1) {
                <div>
                  <button mat-stroked-button color="primary" (click)="onClickOpenApplication(application.id)">
                    VIEW
                  </button>
                </div>
              }
              @if (
                checkUserAuthorization(application.stateCode, application.contractorPermissionsCode, application._Ebb_OwnerId, application._Ebb_ContractorId) === 1 &&
                (application.stageCode === 700000003 &&
                application.eventApplicationSubmitted === true &&
                application.eventFinancialReviewSubmitted === true)
                ) {
                <div
                  >
                  <button mat-stroked-button color="primary" (click)="onClickOpenApplication(application.id)">
                    VIEW
                  </button>
                </div>
              }
              @if (checkUserAuthorization(application.stateCode, application.contractorPermissionsCode, application._Ebb_OwnerId, application._Ebb_ContractorId) === 2 ) {
                <div>
                  <button mat-stroked-button color="primary" (click)="onClickOpenApplication(application.id)">
                    VIEW
                  </button>
                </div>
              }
              @if (checkUserAuthorization(application.stateCode, application.contractorPermissionsCode, application._Ebb_OwnerId, application._Ebb_ContractorId) === 3 ) {
                <div>
                  <button mat-raised-button color="primary" (click)="onClickOpenApplication(application.id)">
                    EDIT
                  </button>
                </div>
              }
            </mat-card-actions>
          </mat-card>
        </div>
      </div>
    }
  </div>
</div>
}

<div class="mat-elevation-z7" style="width: 100%" [hidden]="toggleDisplayCardList">
  <table mat-table [dataSource]="dataSource" matSort matSortActive="_Ebb_OwnerId_Formatted" matSortDirection="asc" style="width: 100%">
    <ng-container matColumnDef="applicationNumber">
      <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header> Application Number </th>
      <td mat-cell width="8%;" *matCellDef="let item">
        <span style="font-size: 14px;">
          {{item.applicationNumber}}
        </span>
      </td>
    </ng-container>
    <ng-container matColumnDef="_Ebb_OwnerId_Formatted">
      <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header>Owner Name </th>
      <td mat-cell width="10%;" *matCellDef="let item">
        <span style="font-size: 14px;">
          {{item._Ebb_OwnerId_Formatted}}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header> Address </th>
      <td mat-cell width="25%;" *matCellDef="let item">
        <span style="font-size: 14px;">
          {{item.name}}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="acceptedDate">
      <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header> Accepted date </th>
      <td mat-cell width="7%;" *matCellDef="let item">
        <span style="font-size: 14px;">
          {{getFormattedDate(item.acceptedDate.toString())}}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="displayretrofitdue">
      <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header> Phase Due Date </th>
      <td mat-cell width="7%;" *matCellDef="let item">
        <span style="font-size: 14px;">
          {{item.displayretrofitdue}}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="_Ebb_ProgramCycleId_Formatted">
      <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header> Program </th>
      <td mat-cell width="10%;" *matCellDef="let item">
        <span style="font-size: 14px;">
          @if (item) {
            <div>
              {{item._Ebb_ProgramCycleId_Formatted | Filename}}
            </div>
          }
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="_EBB_ProgramType">
      <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header> Type </th>
      <td mat-cell width="10%;" *matCellDef="let item">
        <span style="font-size: 14px;">
          @if (item) {
            <div>
              {{programTypeDesc(item.programType)}}
            </div>
          }
        </span>
      </td>
    </ng-container>


    <ng-container matColumnDef="displaystatus">
      <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header> Status </th>
      <td mat-cell width="25%;" *matCellDef="let item">
        <span style="font-size: 14px;">
          @if (isContractorOnApp(item) && item.stateCode === 0 ) {
            <div>
              <div>
                @switch (item.stageCode) {
                  @case (700000000) {
                    <div class="card-value">
                      {{item.displaystatus}}  @if (item.displaystatus === 'Extension') {
                      <span> - {{item.extensionDate | date: 'M/d/yyyy'}}</span>
                      }<br />
                      @if (item.itemsRejectedRollup > 0) {
                        <span>
                          <span class="warn-text">
                            Action Required
                          </span>
                        </span>
                      } @else {
                        @if (item.eventPreliminaryReview) {
                          <span>
                            @if (item.programType !== 700000002) {
                              <span>
                                Submitted
                              </span>
                            }
                            @if (item.programType === 700000002) {
                              <span>
                                <!-- FEMA Review  <br/> -->
                                <span [innerHTML]="femareviewmessage" style=" display: inline-block;color: #377491;"></span>
                              </span>
                            }
                          </span>
                        }
                        @if (!item.eventPreliminaryReview) {
                          <span>
                            @if (isContractorOnApp(item) && !isHomeownerOnApp(item)) {
                              <span class="warn-text">
                                Upload Documents
                              </span>
                            }
                            @if (isHomeownerOnApp(item)) {
                              <span>
                                @if (item.applicationStatusOptionSet !== 'Extension') {
                                  <span>In process</span>
                                }
                                @if (item.applicationStatusOptionSet === 'Extension') {
                                  <span>{{item.extensionDate | date: 'M/d/yyyy'}}</span>
                                }
                              </span>
                            }
                          </span>
                        }
                      }
                    </div>
                  }
                  @case (700000001) {
                    <div class="card-value">
                      {{item.displaystatus}} <br />
                      @if (item.itemsRejectedRollup > 0) {
                        <span>
                          <span class="warn-text">
                            Action Required
                          </span>
                        </span>
                      } @else {
                        @if (item.eventApplicationSubmitted) {
                          <span>
                            Submitted
                          </span>
                        }
                        @if (!item.eventApplicationSubmitted) {
                          <span>
                            <span class="accent-text">
                              Proceed with Project
                            </span>
                          </span>
                        }
                      }
                    </div>
                  }
                  @case (700000002) {
                    <div class="card-value">
                      {{item.displaystatus}} <br />
                      @if (item.itemsRejectedRollup) {
                        <span>
                          <br/>
                          <span class="warn-text">
                            Action Required
                          </span>
                        </span>
                      }
                    </div>
                  }
                  @case (700000003) {
                    <div class="card-value">
                      {{item.displaystatus}}
                      @if (item.itemsRejectedRollup) {
                        <span>
                          <br/>
                          <span class="warn-text">
                            Action Required
                          </span>
                        </span>
                      }
                    </div>
                  }
                }
              </div>
            </div>
          }
          @if (isContractorOnApp(item) && item.stateCode === 1) {
            <div>
              <div>
                @switch (item.statusCode) {
                  @case (700000000) {
                    <div class="card-value">
                      <span style="color: #2a7f48;">
                        {{item.displaystatus}}
                      </span>
                    </div>
                  }
                  @case (700000001) {
                    <div class="card-value">
                      <span style="color: #2a7f48;">
                        {{item.displaystatus}}
                      </span>
                    </div>
                  }
                }
              </div>
            </div>
          }
          @if (!isInspector()) {
            <div>
              <ng-template #showStatusForInspector>
                {{item.displaystatus}}
              </ng-template>
            </div>
          }

        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="action">
      <th scope="col" mat-header-cell *matHeaderCellDef> Action </th>
      <td mat-cell width="10%;" *matCellDef="let item">
        @if (currentContact?.isContractor) {
          <div>
            @if (checkUserAuthorization(item.stageCode, item.contractorPermissionsCode, item._Ebb_OwnerId, item._Ebb_ContractorId) === 1 && item.stageCode <= 1) {
              <div>
                <button mat-stroked-button color="primary" (click)="onClickOpenApplication(item.id)">
                  VIEW
                </button>
              </div>
            }
            @if (
              checkUserAuthorization(item.stateCode, item.contractorPermissionsCode, item._Ebb_OwnerId, item._Ebb_ContractorId) === 1 &&
              (item.stageCode === 700000003 &&
              item.eventApplicationSubmitted === true &&
              item.eventFinancialReviewSubmitted === true)
              ) {
              <div
                >
                <button mat-stroked-button color="primary" (click)="onClickOpenApplication(item.id)">
                  VIEW
                </button>
              </div>
            }
            @if (checkUserAuthorization(item.stateCode, item.contractorPermissionsCode, item._Ebb_OwnerId, item._Ebb_ContractorId) === 2 ) {
              <div>
                <button mat-stroked-button color="primary" (click)="onClickOpenApplication(item.id)">
                  VIEW
                </button>
              </div>
            }
            @if (checkUserAuthorization(item.stateCode, item.contractorPermissionsCode, item._Ebb_OwnerId, item._Ebb_ContractorId) === 3 ) {
              <div>
                <button mat-raised-button color="primary" (click)="onClickOpenApplication(item.id)">
                  EDIT
                </button>
              </div>
            }
          </div>
        } @else {
          <button mat-stroked-button color="primary" (click)="onClickOpenApplication(item.id)">
            VIEW
          </button>
        }
      </td>
    </ng-container>


    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
  <mat-paginator #dataPaginatorOpen="matPaginator" [length]="dataSourceLength" [pageSizeOptions]="tablePageSizeOptions"></mat-paginator>
</div>

</div>

@if (ShowOpenApplicationsMessage) {
  <div style="margin-top: 9px; margin-left: 15px;">
    <p>{{checkForOpenApplications}}</p>
  </div>
}
